const FOOTER_LINKS = [
  {
    title: '热门栏目',
    items: [
      { label: '吃瓜榜单', href: '#ranking' },
      { label: '焦点专题', href: '#carousel' },
      { label: '最新快讯', href: '#updates' },
      { label: '话题广场', href: '#topics' },
      { label: '精彩视频', href: '#media' },
    ],
  },
  {
    title: '特色内容',
    items: [
      { label: '主题索引', href: '#index' },
      { label: '热门吃瓜', href: '#cards' },
      { label: '特色优势', href: '#features' },
      { label: '移动观看', href: '#app' },
      { label: '常见问答', href: '#faq' },
    ],
  },
  {
    title: '关于我们',
    items: [
      { label: '平台介绍', href: '#about' },
      { label: '投稿爆料', href: '#contact' },
      { label: '读者评论', href: '#comments' },
    ],
  },
];

export default function Footer() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <a
              href="#hero"
              onClick={(e) => { e.preventDefault(); handleClick('#hero'); }}
              className="font-heading text-2xl text-primary-400 no-underline whitespace-nowrap"
            >
              黑料吃瓜
            </a>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              黑料吃瓜在线观看高清视频平台，每日更新最新吃瓜内容。提供黑料吃瓜视频、黑料吃瓜短视频、黑料吃瓜最新视频在线观看高清入口，支持免费在线播放，做您身边的吃瓜第一站。
            </p>
          </div>

          {FOOTER_LINKS.map((group) => (
            <div key={group.title}>
              <h3 className="font-heading text-base text-background-100 mb-3">{group.title}</h3>
              <ul className="space-y-2">
                {group.items.map((item) => (
                  <li key={item.label}>
                    <a
                      href={item.href}
                      onClick={(e) => { e.preventDefault(); handleClick(item.href); }}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors no-underline cursor-pointer whitespace-nowrap"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-background-800/60">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 黑料吃瓜网在线观看 - 黑料吃瓜视频高清播放平台
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-background-500">合作伙伴</span>
              <span className="text-xs text-background-600">——</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}